import { render } from "./CyberSecurityPopup.vue?vue&type=template&id=071839a4&scoped=true&ts=true"
import script from "./CyberSecurityPopup.vue?vue&type=script&lang=ts"
export * from "./CyberSecurityPopup.vue?vue&type=script&lang=ts"

import "./CyberSecurityPopup.vue?vue&type=style&index=0&id=071839a4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-071839a4"]])

export default __exports__